import { Component, computed, input } from '@angular/core';

import { IBook } from '../../_models';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'kbm-book-card',
    templateUrl: './book-card.component.html',
    styleUrls: ['./book-card.component.scss'],
    standalone: true,
    imports: [MatCardModule]
})
export class BookCardComponent {

  book = input.required<IBook>();

  name = computed(() => {
    const seriesObjectArray = this.book().series;
    if (seriesObjectArray!.length > 0) {
      return seriesObjectArray![0].name;
    } else {
      return '';
    }
  });

  seriesReadingOrder = computed(() => {
    const seriesObjectArray = this.book().series;
    if (seriesObjectArray!.length > 0) {
      return seriesObjectArray![0].readingOrder;
    } else {
      return -1;
    }
  })


}
